/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SqlImportModel from 'cio/models/sql-import';

interface SqlImportsSyncStatusLabelArgs {
  model: SqlImportModel;
}

export default class SqlImportsSyncStatusLabel extends Component<SqlImportsSyncStatusLabelArgs> {
  get statusInfo() {
    let { model } = this.args;

    let isScheduled = model.active && model.isScheduled;
    let isPaused = !model.active && !model.isDraft;
    let { isDraft } = model;
    let isActive = model.active && !model.isScheduled;

    if (isScheduled) {
      return {
        class: 'is-pending',
        label: 'Scheduled',
      };
    } else if (isPaused) {
      return {
        class: 'is-pending',
        label: 'Paused',
      };
    } else if (isActive) {
      return {
        class: 'is-success',
        label: 'Active',
      };
    } else if (isDraft) {
      return {
        class: 'is-warning',
        label: 'Draft',
      };
    }

    return; // shouldn't ever happen
  }
}
